<template>
  <div>
    <el-divider class="pcb-form__divider" content-position="center">FPC 基本信息</el-divider>
    <!-- 板子层数 -->
    <blayer v-model="fpcParams.blayer" />
    <!-- 拼版款数 -->
    <pbnum ref="pbnum" v-model="fpcParams.pbnum" />
    <!-- 出货形式 -->
    <units 
      v-model="fpcParams.units" 
      :bcount="fpcParams.bcount" 
      :length="fpcParams.length" 
      :width="fpcParams.width" 
      :isSmt="true"
    />
    <!-- 尺寸 -->
    <length 
      ref="length" 
      :length.sync="fpcParams.length" 
      :width.sync="fpcParams.width" 
      :units="fpcParams.units" 
      :sizeTips="sizeTips"
    />
    <!-- 拼版规则 -->
    <layout
      ref="layout"
      v-if="isShow.layout"
      :layoutx.sync="fpcParams.layoutx"
      :layouty.sync="fpcParams.layouty"
      :exampleData="{
        setlength: computePcbSize.length,
        setwidth: computePcbSize.width,
        length: fpcParams.length,
        width: fpcParams.width,
        layouty: fpcParams.layouty,
        layoutx: fpcParams.layoutx,
        bcount: fpcParams.bcount,
        pcsNum: pcsNumForSet,
        m: pcbPrice.m
      }"
    />
    <!-- 数量 -->
    <bcount 
      ref="bcount" 
      v-model="fpcParams.bcount" 
      :units="fpcParams.units" 
      :area="pcbPrice.m"
    />
    <!-- 工艺边框 -->
    <sidewidth 
      ref="sidewidth" 
      v-if="isShow.sidewidth" 
      :sidedirection.sync="fpcParams.sidedirection" 
      :sidewidth.sync="fpcParams.sidewidth" 
      :isSmt="true"
      :sizeTips="sizeTips"
    />

    <el-divider class="pcb-form__divider" content-position="center">FPC 工艺信息</el-divider>
    <!-- 材料 -->
    <material v-model="fpcParams.material" :blayer="fpcParams.blayer" :impendance="fpcParams.impendance" />
    <!-- PI 厚度 -->
    <pi_thickness ref="pi_thickness" v-model="fpcParams.pi_thickness" :blayer="fpcParams.blayer" :bheight="fpcParams.bheight" />
    <!-- 板子厚度 -->
    <bheight ref="bheight" v-model="fpcParams.bheight" :blayer="fpcParams.blayer" />
    <!-- 外层铜厚 -->
    <copper v-model="fpcParams.copper" :blayer="fpcParams.blayer" :bheight="fpcParams.bheight" />
    <!-- 内层铜厚 -->
    <insidecopper v-show="isShow.insidecopper" v-model="fpcParams.insidecopper" :blayer="fpcParams.blayer" />
    <!-- 最小线宽/线距 -->
    <lineweight v-model="fpcParams.lineweight" />
    <!-- 最小线宽/线距 -->
    <vias v-model="fpcParams.vias" />
    <!-- 阻焊类型 -->
    <cover v-model="fpcParams.cover" :blayer="fpcParams.blayer" :initFpcParamsChange="initFpcParamsChange" />
    <!-- 阻焊颜色 -->
    <color v-model="fpcParams.color" :cover="fpcParams.cover" />
    <!-- 字符颜色 -->
    <charcolor v-model="fpcParams.charcolor" :color="fpcParams.color" />
    <div class="quote-container__multicolumn">
      <!-- 表面处理 -->
      <spray v-model="fpcParams.spray" />
      <!-- 沉金厚度 -->
      <cjh v-show="isShow.cjh" v-model="fpcParams.cjh" :spray="fpcParams.spray" />
      <!-- 电金厚度 -->
      <electrogilding_thickness v-show="isShow.electrogilding_thickness" v-model="fpcParams.electrogilding_thickness" :spray="fpcParams.spray" />
    </div>
    <!-- 成型方式 -->
    <forming_type v-model="fpcParams.forming_type" />
    <!-- 补强 -->
    <reinforce ref="reinforce" v-model="fpcParams.reinforce" />
    <!-- 补强类型 -->
    <reinforce_type
      ref="reinforce_type"
      v-if="isShow.reinforce_type"
      :reinforce="fpcParams.reinforce"
      :reinforce_steel.sync="fpcParams.reinforce_steel"
      :steel_thickness.sync="fpcParams.steel_thickness"
      :reinforce_aluminium.sync="fpcParams.reinforce_aluminium"
      :aluminium_thickness.sync="fpcParams.aluminium_thickness"
      :reinforce_fr4.sync="fpcParams.reinforce_fr4"
      :fr4_thickness.sync="fpcParams.fr4_thickness"
      :reinforce_fingerpi.sync="fpcParams.reinforce_fingerpi"
      :fingerpi_thickness.sync="fpcParams.fingerpi_thickness"
      :reinforce_otherpi.sync="fpcParams.reinforce_otherpi"
      :otherpi_thickness.sync="fpcParams.otherpi_thickness"
    />
    <!-- 背胶 -->
    <back_gum_type v-model="fpcParams.back_gum_type" />
    <!-- 电磁膜 -->
    <electromagnetic_membrane ref="electromagnetic_membrane" v-model="fpcParams.electromagnetic_membrane" />
    <!-- 导电胶 -->
    <conducting_resin ref="conducting_resin" v-model="fpcParams.conducting_resin" />
    <!-- 阻抗 -->
    <impendance v-model="fpcParams.impendance" />
    <!-- 层压顺序 -->
    <overlay_type
      ref="overlay_type"
      v-if="isShow.overlay_type"
      :overlay_type.sync="fpcParams.overlay_type"
      :overlay_seq.sync="fpcParams.overlay_seq"
    />

    <el-divider class="pcb-form__divider" content-position="center">FPC 服务信息</el-divider>
    <!-- 测试方式 -->
    <test ref="test" v-model="fpcParams.test" :testOptions="pcbPrice.suggest ? pcbPrice.suggest.test : []" />
    <!-- 确认生产稿 -->
    <review_file 
      ref="review_file" 
      v-model="fpcParams.review_file" 
      :isShowSmtTips="true"
    />
    <!-- 产品报告 -->
    <report v-model="fpcParams.report" :impendance="fpcParams.impendance" />
    <!-- 报告形式 -->
    <report_type ref="report_type" v-if="isShow.report_type" v-model="fpcParams.report_type" />
    <!-- 打叉板 -->
    <cross_board v-model="fpcParams.cross_board" />
  </div>
</template>

<script>
import { scrollTop } from '@@/utils/pageScroll'
import { FPC_DEFAULT_FORM } from '@@/utils/defaultForm'
import { computePcbSize, pcsNumForSet } from '@@/utils/pcbParamsFormat'
import {
  isShowFpcParams,
  formatFpcParams,
  validateFpcSize
} from '@@/utils/fpcParamsFormat'

// 自动注册 pcb fields 文件夹下的订单字段组件
const requireFields = require.context('../../fpc/fields', true, /\.vue$/)
let fieldsComponents = {}
requireFields.keys().forEach(fileName => {
  let component = requireFields(fileName)
  fieldsComponents[fileName.replace(/^\.\/(.*)\.\w+$/, '$1')] = component.default
})

export default {
  props: {
    // 返回修改初始化参数时，参数不进行关联变更
    initFpcParamsChange: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ...fieldsComponents
  },
  inject: {
    fpcParams: { default: { ...FPC_DEFAULT_FORM } },
    getPcbPrice: { default: () => ({}) }
  },
  computed: {
    // 获取实时的计价数据
    pcbPrice() {
      return this.getPcbPrice()
    },
    // 板子面积
    area() {
      return (this.pcbPrice.m || 0) / 10000
    },
    // 相关字段是否显示判断
    isShow() {
      return isShowFpcParams(this.fpcParams)
    },
    // 计算板子尺寸
    computePcbSize() {
      return computePcbSize(this.fpcParams)
    },
    // 连片数量换算为单片数量
    pcsNumForSet() {
      return pcsNumForSet(this.fpcParams)
    },
    // 板子尺寸验证提示
    sizeTips() {
      const valids = validateFpcSize(this.fpcParams).filter(item => {
        const flag = typeof item.flag === 'function' ? item.flag() : item.flag
        return flag
      })
      if (valids.length > 0) {
        return valids[0].tips
      }
      return ''
    }
  },
  methods: {
    scrollIntoView(key) {
      if (this.$refs[key]) {
        // 滚动到元素上面偏移50px的位置
        const top = this.$refs[key].$el.getBoundingClientRect().top
        scrollTop(top, -50)
      }
    },
    validate(data) {
      data.forEach((item, index) => {
        const ref = this.$refs[item.key]
        if (ref && ref.isShowError) {
          // 显示错误提示样式
          ref.isShowError(true, index === 0)
        }
      })
      const fristItem = data[0]
      this.$message.closeAll()
      this.$message({
        type: 'error',
        offset: 400,
        message: fristItem.tips
      })
      this.scrollIntoView(fristItem.key)
    },
  }
}
</script>

<style lang="scss" scoped>
</style>